module.exports = __webpack_public_path__ + "static/media/SFCompactDisplay-Bold.396cbcad.ttf";